import { useEffect, useState } from "react";

const FOOTER_NAV = [
  { label: "热瓜推荐", href: "#hot" },
  { label: "考古时间线", href: "#timeline" },
  { label: "分类档案", href: "#archive" },
  { label: "编辑部特稿", href: "#feature" },
  { label: "常见问题", href: "#faq" },
  { label: "订阅联系", href: "#subscribe" },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="w-full bg-foreground-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-lg font-bold text-background-50">
                吃
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-background-50">吃瓜考古社</span>
                <span className="text-[10px] tracking-[0.2em] text-background-300">CHI GUA KAO GU</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              专注吃瓜八卦历史与陈年往事的时间线整理，为喜欢翻旧账、挖旧料的朋友，提供一份清晰、可靠、有据可查的档案。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-background-100/20 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                  aria-label="关注我们"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-background-200 transition-colors hover:text-accent-300">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">联系档案社</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                hello@chiguakao.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-question-line text-accent-400" />
                旧料线索欢迎投稿
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                编辑部每周更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 吃瓜考古社 · 内容仅供娱乐与信息整理，请理性吃瓜。</p>
          <p className="flex items-center gap-2">
            <i className="ri-archive-2-line" />
            旧料翻旧账 · 陈年时间线 · 吃瓜八卦考古
          </p>
        </div>
      </div>

      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-transform hover:-translate-y-1"
        >
          <i className="ri-arrow-up-line text-xl" />
        </a>
      )}
    </footer>
  );
}